
var sprite = require("/data/jenkins/jobs/deploy_web_common_h5_pipeline/workspace/fe-h5/smart-form/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 48 48\" id=\"cross-circle-o\" ><title>step-48-&#x9519;&#x8BEF;-&#x5B9E;&#x5FC3;</title><path d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm.353-25.77l-7.593-7.593c-.797-.799-1.538-.822-2.263-.207-.724.614-.56 1.617-.124 2.067l7.852 7.847-7.721 7.723c-.726.728-.558 1.646-.065 2.177.494.532 1.554.683 2.312-.174l7.587-7.584 7.644 7.623c.796.799 1.608.725 2.211.146.604-.579.72-1.442-.075-2.24l-7.657-7.669 7.544-7.521c.811-.697.9-1.76.297-2.34-.92-.885-1.849-.338-2.264.078l-7.685 7.667z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "cross-circle-o");


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/assets/cross-circle-o.svg
// module id = 485
// module chunks = 0 1